import React, {useEffect, useState} from "react";
import axios from "axios";
import {ErrorMessage, Field, Form, Formik} from "formik";
import "./DashboardApplicationComponent.css";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import {useNavigate} from 'react-router-dom';
import Select from "react-select";
import LoaderCustom from "../../../components/ConfirmationModal/LoaderCustom";
import {FaAsterisk, FaCalendarAlt, FaInfoCircle, FaPenAlt, FaPlus, FaSearch} from "react-icons/fa";
import {ka} from 'date-fns/locale';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {format} from 'date-fns';
import LocationProps from "../../../enums/LocationProps";
import CaseNotificationEnum from "../../../enums/CaseNotiFicationEnum";
import {jwtDecode} from "jwt-decode";
import {Alert, Chip, Snackbar, Tooltip} from "@mui/material";
import {MdClose} from "react-icons/md";
import ExcelPopup from "../../apiTables/ExcelPopup";
import CaseStatus from "../../../enums/CaseStatus";


const DashboardApplicationComponentForExpert = ({geoIds}) => {
    const token = localStorage.getItem("jwtToken");
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserRole(decoded.role);
            } catch (error) {
                setUserRole("");
            } finally {
            }
        }
    }, [token]);

    const navigate = useNavigate(), baseURL = process.env.REACT_APP_API_BASE_URL,
        urlParams = new URLSearchParams(window.location.search),
        permitTypeIdFromUrl = parseInt(urlParams.get('id'), 10), [municipalities, setMunicipalities] = useState([]), [regions, setRegions] = useState([]), [councils, setCouncils] = useState([]), [populatedAreas, setPopulatedAreas] = useState([]), [title, setTitle] = useState(""), [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false), [formDataToSubmit, setFormDataToSubmit] = useState(null), [inputTypes, setInputTypes] = useState([]), [dropdownOptions, setDropdownOptions] = useState({}), [generateFormik, setGenerateFormik] = useState(false), [creteByExpertCaseNumber, setCreteByExpertCaseNumber] = useState(false), [companyInfo, setCompanyInfo] = useState({}), [caseData, setCaseData] = useState(null), [initialValues, setInitialValues] = useState({
            cadastralCode: '',
            objectName: '',
            address: '',
            municipalityId: [],
            regionId: [],
            councilId: [],
            populatedAreaId: [],
            parentId: '',
            creteByExpertCaseNumber: false,
            oldCaseNumber: ''

        }), [userIp, setUserIp] = useState('421'), [error, setError] = useState(null),


        getUserIpAddress = async () => {
            // List of IP APIs in order of preference
            const ipApis = [
                {
                    name: 'ipify',
                    url: 'https://api.ipify.org?foasfasfrmat=json',
                    parse: async (response) => {
                        const data = await response.json();
                        return data.ip;
                    },
                },
                {
                    name: 'ipinfo',
                    url: 'https://ipinfo.io/json',
                    parse: async (response) => {
                        const data = await response.json();
                        return data.ip;
                    },
                },
                {
                    name: 'icanhazip',
                    url: 'https://icanhazip.com/',
                    parse: async (response) => {
                        const text = await response.text();
                        return text.trim();
                    },
                },
                {
                    name: 'ifconfig.me',
                    url: 'https://ifconfig.me/ip',
                    parse: async (response) => {
                        const text = await response.text();
                        return text.trim();
                    },
                },
            ];

            for (let api of ipApis) {
                try {
                    const response = await fetch(api.url);
                    if (!response.ok) {
                        throw new Error(`API ${api.name} responded with status ${response.status}`);
                    }
                    const ip = await api.parse(response);
                    if (ip) {
                        setUserIp(ip);
                        setError(null);
                        return; // Exit the function after successful fetch
                    }
                } catch (err) {
                    console.warn(`Failed to fetch IP using ${api.name}: ${err.message}`);
                    // Continue to the next API
                }
            }

            // If all APIs fail
            setError('Unable to retrieve IP address. Please try again later.');
            console.error('All IP APIs failed.');
        };



    const sendNotification = async (caseId) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CreateCaseNotificationforHeadOfAgency`, {
                caseId: caseId,
                caseStatus: CaseStatus.Sent.id,
                action: 1
            });

        } catch (error) {
        }
    };

    const decodeJwtToken = () => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            try {
                return jwtDecode(token);
            } catch (error) {
                return null;
            }
        }
        return null;
    };

    const [isExplanationInfoButtonDisabled, setIsExplanationInfoButtonDisabled] = useState(false);
    const [isBoomBoomInfoButtonDisabled, setIsBoomBoomInfoButtonDisabled] = useState(false);
    const [isCompanyInfoButtonDisabled, setIsCompanyInfoButtonDisabled] = useState(false);
    const [objectOwnerValidationEnabled, setObjectOwnerValidationEnabled] = useState(false);
    const [isCompanyDataLoading, setIsCompanyDataIsLoading] = useState(false);
    const [exploitationCompanyValidationEnabled, setExploitationCompanyValidationEnabled] = useState(false);
    const [boomBoomOwnerValidationEnabled, setBoomBoomOwnerValidationEnabled] = useState(false);
    const [companyValidationEnabled, setCompanyValidationEnabled] = useState(false);
    const [objectOwnerInfo, setObjectOwnerInfo] = useState({});
    const [boomBoomOwnerInfo, setBoomBoomOwnerInfo] = useState({});
    const [exploitationCompanyInfo, setExploitationCompanyInfo] = useState({});
    const [cadastralCodeArray, setCadastralCodeArray] = useState([]);
    const [cadastralCode, setCadastralCode] = useState('');
    const [caseHasExploitationField, setCaseHasExploitationField] = useState(false);
    const isMobile = window.innerWidth < 768
    const [alert, setAlert] = useState({message: '', severity: 'info'});
    const [isCadastralCodeLoading, setIsCadastralCodeIsLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);

    const autoSubmitInternalInputs = async (caseId) => {

        const urlParams = new URLSearchParams(window.location.search);
        const parentId = urlParams.get('parentId');
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetInputTypesByCaseID?CaseId=${parentId}`);
            const internalInputs = response.data.data.list.filter(input => input.internal === true);

            if (internalInputs.length > 0) {

                const caseDetails = internalInputs.map(input => ({
                    caseDetailInfo: {
                        caseId: parseInt(caseId, 10),
                        key: input.title,
                        value: '',
                        inputType: 5,
                        dictionaryTypeId: input.value === '' ? null : input.value,
                        dictionaryId: null,
                        hasDeadline: input.hasDeadline,
                        hasFile: input.hasFile,
                        visibleOnTable: true,
                        visibleOnTableForUser: false
                    },
                }));
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddCaseDetails`, {caseDetails});
            } else {
            }
        } catch (error) {
        }

    };

    const regionOptions = regions.map(region => ({value: region.id, label: region.itemName}));
    const councilsOptions = councils.map(council => ({value: council.id, label: council.typesName}));
    const populatedAreasOptions = populatedAreas.map(populatedArea => ({
        value: populatedArea.id,
        label: populatedArea.typesName
    }));
    const municipalitiesOptions = municipalities.map(municipality => ({
        value: municipality.id,
        label: municipality.typesName
    }));

    const formatGeoData = (ids) => {
        return ids.map(id => `-${id}-`).join(",") + ",";
    };


    const fetchPermitType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeByID?Id=${permitTypeIdFromUrl}`);
            setCaseData(response.data.data);
        } catch (error) {
        }
    };
    useEffect(() => {
        if (permitTypeIdFromUrl) {
            void fetchPermitType();
        }
    }, [permitTypeIdFromUrl]);

    const fetchCompanyInfo = async (identificationNumber, fieldName) => {
        setIsCompanyDataIsLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/NAPR_ENREGWS_GetSubjByIdNrQuery?identificationNumber=${identificationNumber}&SettingEndpointKeyWord=GetSubjByIdNrQuery&ipAddress=${userIp}`);
            if (response.data.success) {
                const data = response.data.data;
                if (data.name || data.status) {
                    if (fieldName === "ობიექტის მფლობელის საიდენტიფიკაციო კოდი") {
                        setObjectOwnerValidationEnabled(true)
                        setObjectOwnerInfo(data)
                    } else if (fieldName === "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი") {
                        setExploitationCompanyValidationEnabled(true)
                        setExploitationCompanyInfo(data)
                    } else if (fieldName === "საიდენტიფიკაციო ნომერი") {
                        setBoomBoomOwnerValidationEnabled(true)
                        setBoomBoomOwnerInfo(data)
                    } else {
                        setCompanyValidationEnabled(true)
                        setCompanyInfo(data);
                    }
                    setAlert({message: 'ოპერაცია წარმატებით დასრულდა', severity: 'success'});
                } else {
                    setCompanyInfo({});
                    setAlert({message: 'არაფერი მოიძებნა!', severity: 'warning'});
                }

            } else if (response.data.success === false) {
                setCompanyInfo({});
                setAlert({
                    message: response.data.errors[0]?.message || 'An unknown error occurred',
                    severity: 'error'
                });
            }


        } catch (error) {
            setCompanyInfo({});
            setAlert({message: 'დაფიქსირდა შეცდომა', severity: 'error'});
        }
        setIsCompanyDataIsLoading(false);
        setShowAlert(true);
    };

    useEffect(() => {
        const fetchDropdownOptions = async () => {
            const fetchedDropdownOptions = {};
            for (const inputType of inputTypes) {
                if (inputType.type === 1) {
                    try {
                        const response = await axios.get(`${baseURL}/DictionaryTypesDetalisById?CategoryId=${inputType.valueId}`);
                        if (response.data.success) {
                            fetchedDropdownOptions[inputType.title] = response.data.data.resultlist.map(item => ({
                                value: item.id,
                                label: item.itemName
                            }));
                        }
                    } catch (error) {
                    }
                }
            }
            setDropdownOptions(fetchedDropdownOptions);
        };

        if (inputTypes.length > 0) {
            void fetchDropdownOptions();
        }
    }, [inputTypes]);


    const getPermitTypeIdFromURL = () => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get('id');
    };


    useEffect(() => {
        const updatedInitialValues = inputTypes.reduce((acc, inputType) => {
            acc[inputType.title] = inputType.valueId || '';
            return acc;
        }, {
            cadastralCode: '',
            objectName: '',
            address: '',
            municipalityId: [],
            regionId: [],
            councilId: [],
            populatedAreaId: [],
            parentId: ''
        });

        setInitialValues(updatedInitialValues);
    }, [inputTypes]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const permitTypeId = urlParams.get('parentId');
                const caseId = permitTypeId;
                const permitTypeResponse = await axios.get(`${baseURL}/GetPermitTypeByID?Id=${permitTypeId}`);
                if (permitTypeResponse.data.success) {
                    setTitle(permitTypeResponse.data.data.title);
                }
                const regionsResponse = await axios.get(`${baseURL}/DictionaryTypesDetalisById?CategoryId=${geoIds.regionId}`);
                if (regionsResponse.data.success) {
                    setRegions(regionsResponse.data.data.resultlist);
                }
                const inputTypesResponse = await axios.get(`${baseURL}/GetInputTypesByCaseID?CaseId=${caseId}`);
                if (inputTypesResponse.data.success) {
                    let fetchedInputTypes = inputTypesResponse.data.data.list.filter(inputType => !inputType.internal);

                    fetchedInputTypes = fetchedInputTypes.map(inputType => ({
                        ...inputType,
                        valueId: inputType.value,
                        value: undefined
                    }));
                    fetchedInputTypes.sort((a, b) => a.sort - b.sort);
                    setInputTypes(fetchedInputTypes);

                    const dynamicInitialValues = fetchedInputTypes.reduce((acc, inputType) => {
                        acc[inputType.title] = "";
                        return acc;
                    }, {});

                    setInitialValues(prevValues => ({
                        ...prevValues,
                        ...dynamicInitialValues
                    }));
                    setGenerateFormik(true)
                }
            } catch (error) {
            }
        };

        fetchData();
    }, []);

    const handleDeleteCadastralCode = (codeToDelete) => {
        setCadastralCodeArray((prevArray) => prevArray.filter(code => code !== codeToDelete));
    };

    const handleRegionChange = async (selectedRegionIds) => {
        try {
            const dictionaryRequests = selectedRegionIds.map(regionId => ({
                dictionaryTypeId: geoIds.municipalityId,
                dictionaryId: regionId
            }));

            const response = await axios.post(`${baseURL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});

            if (response.data.success) {
                setMunicipalities(response.data.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleMunicipalityChange = async (selectedMunicipalityIds) => {
        try {
            const dictionaryRequests = selectedMunicipalityIds.map(municipalityId => ({
                dictionaryTypeId: geoIds.councilId,
                dictionaryId: municipalityId
            }));

            const response = await axios.post(`${baseURL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});

            if (response.data.success) {
                setCouncils(response.data.data);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleCouncilChange = async (selectedCouncilIds) => {
        try {
            const dictionaryRequests = selectedCouncilIds.map(councilId => ({
                dictionaryTypeId: geoIds.cityId,
                dictionaryId: councilId
            }));
            const response = await axios.post(`${baseURL}/GetAllDictionaryByDictionaryId`, {items: dictionaryRequests});
            if (response.data.success) {
                setPopulatedAreas(response.data.data);
            }
        } catch (error) {
            console.error(error);
        }
    };


    const openConfirmationModal = () => {
        setIsConfirmationModalOpen(true);
    };
    const closeConfirmationModal = () => {
        setIsConfirmationModalOpen(false);
    };
    const [formInteracted, setFormInteracted] = useState(false);


    const handleInteraction = () => {
        if (!formInteracted) setFormInteracted(true);
    };

    const removeDataFromIntegrationFields = (fieldName) => {
        if (fieldName === "ობიექტის მფლობელის საიდენტიფიკაციო კოდი") {
            setObjectOwnerInfo({})
        } else if (fieldName === "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი") {
            setExploitationCompanyInfo({})
        } else if (fieldName === "საიდენტიფიკაციო ნომერი") {
            setBoomBoomOwnerInfo({})
        } else {
            setCompanyInfo({});
        }
    };

    const removeValidationFromIdentification = (fieldName) => {
        if (fieldName === "ობიექტის მფლობელის საიდენტიფიკაციო კოდი") {
            setObjectOwnerValidationEnabled(false)
            setObjectOwnerInfo({})
        } else if (fieldName === "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი") {
            setExploitationCompanyValidationEnabled(false)
            setExploitationCompanyInfo({})
        } else if (fieldName === "საიდენტიფიკაციო ნომერი") {
            setBoomBoomOwnerValidationEnabled(false)
            setBoomBoomOwnerInfo({})
        } else {
            setCompanyValidationEnabled(false)
            setCompanyInfo({});
        }
    };

    const fetchCadastralCode = async (cadastralCode) => {
        if (!cadastralCode) {
            return;
        }
        setIsCadastralCodeIsLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetCADCodeByCadastralCode?CadastralCode=${cadastralCode}`);
            if (response.data.success) {
                if (response.data.success) {
                    setCadastralCodeArray(prevArray => {
                        if (!prevArray.includes(cadastralCode)) {
                            setCadastralCode('');
                            setAlert({message: 'ოპერაცია წარმატებით დასრულდა!', severity: 'success'});
                            return [...prevArray, cadastralCode];
                        } else {
                            setAlert({message: 'საკადასტრო კოდი უკვე დამატებულია სიაში!', severity: 'warning'});
                            return prevArray;
                        }
                    });

                } else {
                    setAlert({message: 'საკადასტრო კოდი არ არსებობს!', severity: 'warning'});
                }
            } else if (!response.data.success) {
                const errorMessage = response.data.errors.message || 'საკადასტრო კოდი არასწორია';
                setAlert({message: errorMessage, severity: 'error'});
            } else {
                setAlert({message: 'დაფიქსირდა შეცდომა!', severity: 'error'});
            }
        } catch (error) {
            setAlert({message: 'დაფიქსირდა შეცდომა!', severity: 'error'});
        }
        setIsCadastralCodeIsLoading(false);
        setShowAlert(true);
    };

    const handleSubmit = (values, {validateForm}) => {

        validateForm().then(errors => {
            if (Object.keys(errors).length === 0) {
                const serializedValues = {
                    ...values,
                    regionId: values.regionId?.length > 0 ? formatGeoData(values.regionId) : "",
                    municipalityId: values.municipalityId?.length > 0 ? formatGeoData(values.municipalityId) : "",
                    councilId: values.councilId?.length > 0 ? formatGeoData(values.councilId) : "",
                    populatedAreaId: values.populatedAreaId?.length > 0 ? formatGeoData(values.populatedAreaId) : "",
                    oldCaseNumber: creteByExpertCaseNumber ? values.oldCaseNumber || null : null,

                };
                setFormDataToSubmit(serializedValues);
                openConfirmationModal();
            }
        });
    };

    const handleFormSubmit = async () => {
        try {
            const formattedData = {...formDataToSubmit};
            inputTypes.forEach(inputType => {
                if (inputType.type === 5 && formattedData[inputType.title]) {
                    formattedData[inputType.title] = format(new Date(formattedData[inputType.title]), 'dd/MM/yyyy');
                }
            });

            const payload = {
                settingEndpointKeyWord: 'AddNewCase',
                ipAddress: "124124",
                sckipCheck: true,
                permitTypeId: parseInt(getPermitTypeIdFromURL(), 10),
                regionId: formattedData.regionId,
                cityId: formattedData.municipalityId,
                councilId: formattedData.councilId,
                populatedAreaId: formattedData.populatedAreaId,
                objectName: "",
                cadastralCode: cadastralCodeArray.length > 0 ? cadastralCodeArray.join('$') : "",
                address: "",
                requestedSpeedUp: false,
                finished: false,
                creteByExpert: userRole !== "ROOTADMIN",
                acceleration: false,
                permitTypePriceId: null,
                councilRejected: LocationProps.notDeclined,
                populatedAreaRejected: LocationProps.notDeclined,
                regionRejected: LocationProps.notDeclined,
                cityRejected: LocationProps.notDeclined,
                creteByExpertCaseNumber: creteByExpertCaseNumber,
                caseParentId: parseInt(formattedData.parentId, 10) || null,
                oldCaseNumber: formattedData.oldCaseNumber ? formattedData.oldCaseNumber : null,
                createObjectRegistryID: creteByExpertCaseNumber
            };

            const addNewCaseResponse = await axios.post(`${baseURL}/AddNewCase`, payload);

            if (addNewCaseResponse.data.success && addNewCaseResponse.data.resultId !== undefined) {
                const resultId = addNewCaseResponse.data.resultId;
                const caseDetails = inputTypes.map(inputType => {
                    let value = formattedData[inputType.title];
                    return {
                        caseDetailInfo: {
                            caseId: parseInt(resultId, 10),
                            key: inputType.title,
                            value: value ? value : "",
                            inputType: inputType.type === 1 ? 1 : 0,
                            dictionaryTypeId: inputType.valueId || null,
                            dictionaryId: dropdownOptions[inputType.title]?.find(option => option.label === value)?.value || null,
                            hasDeadline: false,
                            hasFile: false,
                            unicId: inputType.unicId,
                            visibleOnTable: inputType.visibleOnTable,
                            visibleOnTableForUser: inputType.visibleOnTableForUser
                        },
                    };
                })

                const addCaseDetailsResponse = await axios.post(`${baseURL}/AddCaseDetails`, {caseDetails});
                const urlParams = new URLSearchParams(window.location.search);
                const caseIdFromUrlForInputTypes = urlParams.get('parentId');


                if (addCaseDetailsResponse.data.success) {
                    const decodedToken = decodeJwtToken();
                    if (decodedToken) {

                        const caseNotification = {
                            nextStepUserId: decodedToken.UserId,
                            caseId: parseInt(resultId, 10),
                            documentId: null,
                            action: CaseNotificationEnum.newCaseExpert.id,
                            caseStatus: 8,
                            viewed: false
                        };
                        await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);

                    }

                    await autoSubmitInternalInputs(resultId)
                    closeConfirmationModal();
                    if (userRole === "ROOTADMIN") {
                        await sendNotification()
                    }

                    navigate(`/dashboard/newcase/uploadfilesexpert?id=${getPermitTypeIdFromURL()}&caseid=${resultId}&municipalityId=${parseInt(formattedData.municipalityId, 10)}&parentId=${caseIdFromUrlForInputTypes}`);
                }
            }
        } catch (error) {
        }
    };


    const customStyles = {
        control: (provided) => ({
            ...provided,
            width: '446px',
            cursor: "pointer",
            minHeight: '60px',
            backgroundColor: '#f4f6fa',
            borderRadius: '15px',
            border: 'none',
            color: '#93a6cc',
            fontSize: '18px',
            fontFamily: 'FiraGO-Regular, serif',
            paddingLeft: '40px',
            transition: 'color 0.3s ease, background-color 0.3s ease',
        }),
        option: (provided) => ({
            ...provided,
            color: '#93a6cc',
            cursor: "pointer",
            fontFamily: 'FiraGO-Regular, serif',
            paddingLeft: '40px',
        }),
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: '#93a6cc',
            }
        }
    };

    const renderError = (message) => <p className="help is-danger">{message}</p>;

    return (
        <div className={"apl-container"}>
            {!generateFormik || userIp === '' ? (
                <LoaderCustom/>
            ) : (Object.keys(initialValues).length > 0 && (
                <div className={"apl-component"}>
                    <h1 className="apl-title">{title}</h1>
                    <ExcelPopup isVisible={isCompanyDataLoading} loaderText={"მონაცემები მუშავდება"}
                                loaderType={"CompanyInfo"}/>
                    <ExcelPopup isVisible={isCadastralCodeLoading}
                                loaderText={"მიმდინარეობს საკადასტრო კოდის ვერიფიკაცია"}
                                loaderType={"CadastralCode"}/>

                    <Snackbar
                        open={showAlert}
                        autoHideDuration={6000}
                        onClose={() => {
                            setShowAlert(false);
                            setAlert({message: '', severity: 'info'})
                        }}
                        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                    >
                        <Alert onClose={() => {
                            setShowAlert(false);
                            setAlert({message: '', severity: 'info'})
                        }} severity={alert.severity} sx={{width: '100%'}}>
                            {alert.message}
                        </Alert>
                    </Snackbar>
                    <Formik
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                        validateOnBlur={true}
                        validateOnChange={true}
                    >
                        <Form onChange={handleInteraction}>
                            <div className="field">
                                <div style={{display: "flex", gap: 5}}>
                                    <label className="label-font" htmlFor="regionId">რეგიონი</label>

                                    <div title={"აირჩიეთ ქვეყნის რეგიონი"}>
                                        <FaInfoCircle className={"input-info-icon"}/>
                                    </div>
                                </div>
                                <div className="control">
                                    <Field name="regionId">
                                        {({field, form}) => (
                                            <Select
                                                options={regionOptions}
                                                name="regionId"
                                                isMulti={true}
                                                value={regionOptions.filter(option => field.value.includes(option.value))}
                                                onChange={options => {
                                                    const values = options ? options.map(option => option.value) : [];
                                                    form.setFieldValue("regionId", values);
                                                    void handleRegionChange(values);
                                                }}
                                                placeholder="აირჩიეთ რეგიონი"
                                                styles={customStyles}
                                                isSearchable
                                                noOptionsMessage={() => "არაფერი მოიძებნა"}
                                            />
                                        )}
                                    </Field>
                                    <ErrorMessage name="regionId" render={renderError}/>
                                </div>
                            </div>
                            <div className="field">
                                <div style={{display: "flex", gap: 5}}>
                                    <label className="label-font"
                                           htmlFor="municipalityId">მუნიციპალიტეტი</label>

                                    <div title={"აირჩიეთ მუნიციპალიტეტი"}>
                                        <FaInfoCircle className={"input-info-icon"}/>
                                    </div>
                                </div>
                                <div className="control">
                                    <Field name="municipalityId">
                                        {({field, form}) => (
                                            <Select
                                                options={municipalitiesOptions}
                                                isMulti={true}
                                                name="municipalityId"
                                                value={municipalitiesOptions.filter(option => field.value.includes(option.value))}
                                                onChange={options => {
                                                    const values = options ? options.map(option => option.value) : [];
                                                    form.setFieldValue("municipalityId", values);
                                                    void handleMunicipalityChange(values);
                                                }}
                                                placeholder="აირჩიეთ მუნიციპალიტეტი"
                                                styles={customStyles}
                                                isSearchable
                                                noOptionsMessage={() => "ჯერ აირჩიეთ რეგიონი"}
                                            />
                                        )}
                                    </Field>
                                    <ErrorMessage name="municipalityId" render={renderError}/>
                                </div>
                            </div>
                            <>
                                <div className="field">
                                    <div style={{
                                        display: "flex",
                                        gap: 5,
                                        marginTop: 15
                                    }}>
                                        <label className="label-font"
                                               htmlFor="municipalityId">საკადასტრო კოდი</label>
                                        <div
                                            title={"არსებობის შემთხვევაში მიუთითეთ ის საკადასტრო კოდი, რომელზეც განლაგებულია თქვენს მფლობელობაში მყოფი ობიექტი"}>
                                            <FaInfoCircle

                                                className={"input-info-icon"}/>
                                        </div>
                                    </div>
                                    <div className="control input-wrapper has-icons-right">
                                        <Field
                                            type="text"
                                            className="custom-input-cadastral"
                                            placeholder="საკადასტრო კოდი"
                                            maxLength="700"
                                            name="cadastralCode"
                                        >
                                            {({field, form}) => (
                                                <div className="control has-icons-right">
                                                    <input
                                                        className="custom-input-cadastral"
                                                        style={{
                                                            border: alert.message === "საკადასტრო კოდი არასწორია" ? '1px solid red' :
                                                                alert.message === "საკადასტრო კოდი უკვე დამატებულია სიაში!" ? '1px solid yellow'
                                                                    : "none"
                                                        }}
                                                        value={cadastralCode}
                                                        placeholder={"საკადასტრო კოდი"}
                                                        onChange={(e) => setCadastralCode(e.target.value)}
                                                    />
                                                    <div>
                                                        <div>
                                                            <Tooltip
                                                                title={cadastralCode === "" ? "გთხოვთ შეიყვანოთ საკადასტრო კოდი" : "საკადასტრო კოდის დამატება"}
                                                            >
                                                                <div
                                                                    className="uniqueId-icon-wrapper-build">
                                                                    <FaPlus
                                                                        className={"input-search-button" + (cadastralCode === "" ? " disabled" : "")}
                                                                        onClick={() => fetchCadastralCode(cadastralCode)}
                                                                        style={{
                                                                            cursor: cadastralCode === "" ? "not-allowed" : "pointer",
                                                                            color: cadastralCode === "" ? "#ccc" : "#0e5bd0"
                                                                        }}
                                                                    />
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </Field>
                                    </div>
                                </div>


                                {cadastralCodeArray.length > 0 && (
                                    <>
                                        <label className="label-font">არჩეული საკადასტრო კოდები:</label>
                                        <div className="casecreate-chips-container">
                                            {cadastralCodeArray.map((code, index) => (
                                                <Chip
                                                    key={index}
                                                    label={code}
                                                    onDelete={() => handleDeleteCadastralCode(code)}
                                                    deleteIcon={<MdClose/>}
                                                    className="casecreate-chips-chip"
                                                />
                                            ))}
                                        </div>
                                    </>
                                )}
                            </>
                            {inputTypes.map((inputType, index) => {
                                if (inputType.type === 1) {
                                    return dropdownOptions[inputType.title] ? (

                                        <div className="field" key={"div" + inputType.id}>
                                            <div style={{display: "flex", gap: 10}}>
                                                <label className="label-font" htmlFor={inputType.title}
                                                       id={`input${index + 1}`}>{inputType.title}</label>

                                                {inputType.description && inputType.description !== "" && (
                                                    <div title={inputType.description}>
                                                        <FaInfoCircle className={"input-info-icon"}/>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="control">
                                                <Field name={inputType.title}>
                                                    {({field, form}) => (
                                                        <Select
                                                            options={dropdownOptions[inputType.title]}
                                                            name={inputType.title}
                                                            value={dropdownOptions[inputType.title].find(option => option.value === field.value)}
                                                            onChange={option => {
                                                                form.setFieldValue(inputType.title, option.label);
                                                            }}
                                                            placeholder={inputType.title}
                                                            styles={customStyles}
                                                            isSearchable
                                                        />
                                                    )}
                                                </Field>
                                                <ErrorMessage name={inputType.title} render={renderError}/>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>იტვირთება...</div>
                                    );
                                } else if (inputType.type === 5) {
                                    return (
                                        <div className="field" key={"div" + inputType.id}>
                                            <label className="label-font"
                                                   htmlFor={inputType.title}>{inputType.title}</label>
                                            <div className="control">
                                                <>
                                                    <Field name={inputType.title}>
                                                        {({form, field}) => (
                                                            <DatePicker
                                                                {...field}
                                                                selected={(field.value && new Date(field.value)) || null}
                                                                onChange={val => form.setFieldValue(field.name, val)}
                                                                locale={ka}
                                                                dateFormat="dd/MM/yyyy"
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                className="custom-input"
                                                                placeholderText={inputType.title}
                                                                yearDropdownItemNumber={15}
                                                                scrollableYearDropdown
                                                                customInput={<input readOnly/>}
                                                                icon={<FaCalendarAlt/>}
                                                            />
                                                        )}
                                                    </Field>
                                                </>
                                                <ErrorMessage name={inputType.title} render={renderError}/>
                                            </div>
                                        </div>
                                    );
                                } else if (inputType.integration === 1) {
                                    return (
                                        <div className="field" key={"div" + inputType.id}>
                                            <div style={{display: "flex", gap: 10}}>
                                                <label className="label-font" id={`input${index + 1}`}
                                                       htmlFor={inputType.title}>{inputType.title}</label>

                                                {inputType.description && inputType.description !== "" && (
                                                    <div title={inputType.description}>
                                                        <FaInfoCircle

                                                            className={"input-info-icon"}/>
                                                    </div>
                                                )}

                                            </div>
                                            <div className="control input-wrapper has-icons-right">
                                                <Field
                                                    name={inputType.title}
                                                    type="text"
                                                    className="custom-input-company-main"
                                                    placeholder={inputType.title}
                                                    key={"field" + inputType.id}
                                                    maxLength="700"
                                                    pattern="\d*"
                                                >
                                                    {({field, form}) => (
                                                        <div className="control has-icons-right">
                                                            <div className="company-info-input-wrapper">
                                                                <input
                                                                    className="custom-input-company-main"
                                                                    placeholder={inputType.title}
                                                                    {...field}
                                                                    onChange={e => {
                                                                        const validatedValue = e.target.value.replace(/[^\d]/g, '');
                                                                        form.setFieldValue(field.name, validatedValue);
                                                                        removeDataFromIntegrationFields(field.name)
                                                                    }}
                                                                />
                                                                <div>

                                                                    <div>
                                                                        <Tooltip
                                                                            title={
                                                                                field.value.length === 0 ? `გთხოვთ შეიყვანოთ ${inputType.title}` :
                                                                                    !(field.value.length === 9 || field.value.length === 11) ? `${inputType.title} უნდა იყოს 9 ნიშნა ან 11 ნიშნა!`
                                                                                        : !/^\d+$/.test(field.value) ? `${inputType.title} უნდა შეიცავდეს მხოლოდ ციფრებს!`
                                                                                            : ""
                                                                            }>
                                                                                <span>
                                                                                    {isMobile ? (
                                                                                        <div
                                                                                            className={`identification-search-icon${!(field.value.length === 9 || field.value.length === 11) || !/^\d+$/.test(field.value) ? " disabled" : ""}`}
                                                                                            onClick={() => /^\d+$/.test(field.value) && (field.value.length === 9 || field.value.length === 11) && fetchCompanyInfo(field.value, inputType.title)}
                                                                                        >ძიება</div>
                                                                                    ) : (
                                                                                        <FaSearch
                                                                                            className={`identification-search-icon${!(field.value.length === 9 || field.value.length === 11) || !/^\d+$/.test(field.value) ? " disabled" : ""}`}
                                                                                            onClick={() => /^\d+$/.test(field.value) && (field.value.length === 9 || field.value.length === 11) && fetchCompanyInfo(field.value, inputType.title)}
                                                                                        />
                                                                                    )}

                                                                                </span>
                                                                        </Tooltip>
                                                                        {field.value !== '' && (
                                                                            <>
                                                                                {isMobile ? (
                                                                                    <Tooltip
                                                                                        title={"საიდენტიფიკაციო მონაცემების ხელით შეყვანა"}>
                                                                                        <span>
                                                                                            <div
                                                                                                className={`identification-search-icon`}
                                                                                                onClick={e => {
                                                                                                    form.setFieldValue(field.name, '');
                                                                                                    removeDataFromIntegrationFields(field.name);
                                                                                                    removeValidationFromIdentification(field.name);
                                                                                                }}
                                                                                            >
                                                                                               ხელით შეყვანა

                                                                                            </div>
                                                                                        </span>
                                                                                    </Tooltip>
                                                                                ) : (
                                                                                    <Tooltip
                                                                                        title={"საიდენტიფიკაციო მონაცემების ხელით შეყვანა"}>
                                                                                        <span>
                                                                                            <FaPenAlt
                                                                                                className={`identification-search-icon`}
                                                                                                onClick={e => {
                                                                                                    form.setFieldValue(field.name, '');
                                                                                                    removeDataFromIntegrationFields(field.name);
                                                                                                    removeValidationFromIdentification(field.name);
                                                                                                }}
                                                                                            />
                                                                                        </span>
                                                                                    </Tooltip>
                                                                                )}

                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Field>


                                                <ErrorMessage name={inputType.title} render={renderError}/>
                                            </div>
                                        </div>
                                    );
                                } else if (inputType.type === 2) {
                                    return (
                                        <div className="field" key={"div" + inputType.id}>
                                            <div style={{display: "flex", gap: 10}}>
                                                <label className="label-font" id={`input${index + 1}`}
                                                       htmlFor={inputType.title}>{inputType.title}</label>
                                                {inputType.required && (
                                                    <div title={"სავალდებულო"}>
                                                        <FaAsterisk className="required-icon"/>
                                                    </div>
                                                )}

                                                {inputType.description && inputType.description !== "" && (
                                                    <div title={inputType.description}>
                                                        <FaInfoCircle

                                                            className={"input-info-icon"}/>

                                                    </div>
                                                )}

                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={inputType.title}
                                                    as="textarea"
                                                    className="custom-input-oldTextArea"
                                                    placeholder={inputType.title}
                                                    key={"field" + inputType.id}
                                                />
                                                <ErrorMessage name={inputType.title} render={renderError}/>
                                            </div>
                                        </div>
                                    );
                                } else if (inputType.type === 3) {
                                    return (
                                        <div className="field" key={"div" + inputType.id}>
                                            <div style={{display: "flex", gap: 10}}>
                                                <label className="label-font" id={`input${index + 1}`}
                                                       htmlFor={inputType.title}>{inputType.title}</label>

                                                <div
                                                    title={inputType.title}>
                                                    <FaInfoCircle

                                                        className={"input-info-icon"}/>
                                                </div>
                                            </div>

                                            <div className="control">
                                                {inputType.title === "ობიექტის ექსპლუატაციის გამწევი პირის იურიდიული მისამართი" ? (
                                                        <div>
                                                            {exploitationCompanyValidationEnabled ? (
                                                                <Tooltip title={"არარედაქტირებადი!"}>
                                                                    <span>
                                                                        <Field
                                                                            name={inputType.title}
                                                                            type="text"
                                                                            className="custom-input-company"
                                                                            placeholder={inputType.title}
                                                                            key={"field" + inputType.id}
                                                                            disabled={true}
                                                                            value={exploitationCompanyInfo[inputType.integrationPropertyName] || ''}
                                                                        />
                                                                    </span>
                                                                </Tooltip>
                                                            ) : (
                                                                <span>
                                                                    <Field
                                                                        name={inputType.title}
                                                                        type="text"
                                                                        className="custom-input"
                                                                        placeholder={inputType.title}
                                                                        key={"field" + inputType.id}
                                                                        maxLength="700"
                                                                    />
                                                                </span>
                                                            )}
                                                            {caseHasExploitationField && (
                                                                <>
                                                                    <div className="field">
                                                                        <div style={{
                                                                            display: "flex",
                                                                            gap: 5,
                                                                            marginTop: 15
                                                                        }}>
                                                                            <label className="label-font"
                                                                                   htmlFor="municipalityId">საკადასტრო
                                                                                კოდი</label>
                                                                            <div
                                                                                title={"არსებობის შემთხვევაში მიუთითეთ ის საკადასტრო კოდი, რომელზეც განლაგებულია თქვენს მფლობელობაში მყოფი ობიექტი"}>
                                                                                <FaInfoCircle
                                                                                    className={"input-info-icon"}/>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                        >
                                                                            <Field
                                                                                type="text"
                                                                                className="custom-input-cadastral-object"
                                                                                placeholder="საკადასტრო კოდი"
                                                                                maxLength="700"
                                                                                name="cadastralCode"
                                                                            >
                                                                                {({field, form}) => (
                                                                                    <div
                                                                                        className="control has-icons-right">
                                                                                        <input
                                                                                            style={{
                                                                                                border: alert.message === "საკადასტრო კოდი არასწორია" ? '1px solid red' :
                                                                                                    alert.message === "საკადასტრო კოდი უკვე დამატებულია სიაში!" ? '1px solid yellow'
                                                                                                        : "none"
                                                                                            }}
                                                                                            value={cadastralCode}
                                                                                            className="custom-input-cadastral-object"
                                                                                            placeholder={"საკადასტრო კოდი"}
                                                                                            onChange={(e) => setCadastralCode(e.target.value)}
                                                                                        />
                                                                                        <div>
                                                                                            <div>
                                                                                                <Tooltip
                                                                                                    title={cadastralCode === "" ? "გთხოვთ შეიყვანოთ საკადასტრო კოდი" : "საკადასტრო კოდის დამატება"}
                                                                                                >
                                                                                                    <div
                                                                                                        className="uniqueId-icon-wrapper">
                                                                                                        <FaPlus
                                                                                                            className={"input-search-button" + (cadastralCode === "" ? " disabled" : "")}
                                                                                                            onClick={() => fetchCadastralCode(cadastralCode)}
                                                                                                            style={{
                                                                                                                cursor: cadastralCode === "" ? "not-allowed" : "pointer",
                                                                                                                color: cadastralCode === "" ? "#ccc" : "#0e5bd0"
                                                                                                            }}
                                                                                                        />
                                                                                                    </div>
                                                                                                </Tooltip>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </Field>
                                                                        </div>
                                                                    </div>
                                                                    {cadastralCodeArray.length > 0 && (
                                                                        <>
                                                                            <label className="label-font">არჩეული
                                                                                საკადასტრო
                                                                                კოდები:</label>
                                                                            <div className="casecreate-chips-container">
                                                                                {cadastralCodeArray.map((code, index) => (
                                                                                    <Chip
                                                                                        key={index}
                                                                                        label={code}
                                                                                        onDelete={() => handleDeleteCadastralCode(code)}
                                                                                        deleteIcon={<MdClose/>}
                                                                                        className="casecreate-chips-chip"
                                                                                    />
                                                                                ))}
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}

                                                        </div>
                                                    ) :
                                                    inputType.title === "ობიექტის ექსპლუატაციის გამწევი პირის დასახელება" ? (


                                                            exploitationCompanyValidationEnabled ? (
                                                                <Tooltip title={"არარედაქტირებადი!"}>
                                                                        <span>
                                                                            <Field
                                                                                name={inputType.title}
                                                                                type="text"
                                                                                className="custom-input-company"
                                                                                placeholder={inputType.title}
                                                                                key={"field" + inputType.id}
                                                                                disabled={true}
                                                                                value={exploitationCompanyInfo[inputType.integrationPropertyName] || ''}
                                                                            />
                                                                        </span>
                                                                </Tooltip>
                                                            ) : (
                                                                <span>
                                                                                <Field
                                                                                    name={inputType.title}
                                                                                    type="text"
                                                                                    className="custom-input"
                                                                                    placeholder={inputType.title}
                                                                                    key={"field" + inputType.id}
                                                                                    maxLength="700"
                                                                                />
                                                                            </span>
                                                            )
                                                        ) :
                                                        inputType.title === "ობიექტის ექსპლუატაციის გამწევი პირის დასახელება" ? (

                                                                exploitationCompanyValidationEnabled ? (
                                                                    <Tooltip title={"არარედაქტირებადი!"}>
                                                                        <div>
                                                                            <Field
                                                                                name={inputType.title}
                                                                                type="text"
                                                                                className="custom-input-company"
                                                                                placeholder={inputType.title}
                                                                                key={"field" + inputType.id}
                                                                                disabled={true}
                                                                                value={exploitationCompanyInfo[inputType.integrationPropertyName] || ''}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <div>
                                                                        <Field
                                                                            name={inputType.title}
                                                                            type="text"
                                                                            className="custom-input"
                                                                            placeholder={inputType.title}
                                                                            key={"field" + inputType.id}
                                                                            maxLength="700"
                                                                        />
                                                                    </div>
                                                                )

                                                            ) :
                                                            inputType.title === "ობიექტის მფლობელის დასახელება" ? (

                                                                    objectOwnerValidationEnabled ? (
                                                                        <Tooltip title={"არარედაქტირებადი!"}>
                                                                                    <span>
                                                                                        <Field
                                                                                            name={inputType.title}
                                                                                            type="text"
                                                                                            className="custom-input-company"
                                                                                            placeholder={inputType.title}
                                                                                            key={"field" + inputType.id}
                                                                                            disabled={true}
                                                                                            value={objectOwnerInfo[inputType.integrationPropertyName] || ''}
                                                                                        />
                                                                                    </span>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <span>
                                                                                <Field
                                                                                    name={inputType.title}
                                                                                    type="text"
                                                                                    className="custom-input"
                                                                                    placeholder={inputType.title}
                                                                                    key={"field" + inputType.id}
                                                                                    maxLength="700"
                                                                                />
                                                                            </span>
                                                                    )

                                                                ) :
                                                                inputType.title === "ორგანიზაციის იურიდიული მისამართი" ? (


                                                                        boomBoomOwnerValidationEnabled ? (
                                                                            <Tooltip title={"არარედაქტირებადი!"}>
                                                                                <span>
                                                                                    <Field
                                                                                        name={inputType.title}
                                                                                        type="text"
                                                                                        className="custom-input-company"
                                                                                        placeholder={inputType.title}
                                                                                        key={"field" + inputType.id}
                                                                                        disabled={true}
                                                                                        value={boomBoomOwnerInfo[inputType.integrationPropertyName] || ''}
                                                                                    />
                                                                                </span>
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <span>
                                                                                <Field
                                                                                    name={inputType.title}
                                                                                    type="text"
                                                                                    className="custom-input"
                                                                                    placeholder={inputType.title}
                                                                                    key={"field" + inputType.id}
                                                                                    maxLength="700"
                                                                                />
                                                                            </span>
                                                                        )
                                                                    ) :

                                                                    inputType.title === "ნებართვის მაძიებელი/მფლობელი ორგანიზაცია" ? (


                                                                            boomBoomOwnerValidationEnabled ? (
                                                                                <Tooltip title={"არარედაქტირებადი!"}>
                                                                                <span>
                                                                                        <Field
                                                                                            name={inputType.title}
                                                                                            type="text"
                                                                                            className="custom-input-company"
                                                                                            placeholder={inputType.title}
                                                                                            key={"field" + inputType.id}
                                                                                            disabled={true}
                                                                                            value={boomBoomOwnerInfo[inputType.integrationPropertyName] || ''}
                                                                                        />
                                                                                    </span>
                                                                                </Tooltip>
                                                                            ) : (
                                                                                <span>
                                                                                <Field
                                                                                    name={inputType.title}
                                                                                    type="text"
                                                                                    className="custom-input"
                                                                                    placeholder={inputType.title}
                                                                                    key={"field" + inputType.id}
                                                                                    maxLength="700"
                                                                                />
                                                                            </span>
                                                                            )
                                                                        ) :
                                                                        inputType.title === "ობიექტის მფლობელის იურიდიული მისამართი" ? (
                                                                            objectOwnerValidationEnabled ? (
                                                                                <Tooltip
                                                                                    title={"არარედაქტირებადი!"}>
                                                                                            <span>
                                                                                                <Field
                                                                                                    name={inputType.title}
                                                                                                    type="text"
                                                                                                    className="custom-input-company"
                                                                                                    placeholder={inputType.title}
                                                                                                    key={"field" + inputType.id}
                                                                                                    disabled={true}
                                                                                                    value={objectOwnerInfo[inputType.integrationPropertyName] || ''}
                                                                                                />
                                                                                            </span>
                                                                                </Tooltip>
                                                                            ) : (
                                                                                <span>
                                                                                            <Field
                                                                                                name={inputType.title}
                                                                                                type="text"
                                                                                                className="custom-input"
                                                                                                placeholder={inputType.title}
                                                                                                key={"field" + inputType.id}
                                                                                                maxLength="700"
                                                                                            />
                                                                                        </span>
                                                                            )

                                                                        ) : (
                                                                            <span>
                                                                                        <Field
                                                                                            name={inputType.title}
                                                                                            type="text"
                                                                                            className="custom-input-company"
                                                                                            placeholder={inputType.title}
                                                                                            key={"field" + inputType.id}
                                                                                            disabled={true}
                                                                                            value={companyInfo[inputType.integrationPropertyName] || ''}
                                                                                        />
                                                                                    </span>
                                                                        )}

                                                <ErrorMessage name={inputType.title} render={renderError}/>
                                            </div>

                                        </div>
                                    );
                                } else {
                                    return (
                                        <div className="field" key={"div" + inputType.id}>
                                            <div style={{display: "flex", gap: 10}}>
                                                <label className="label-font" id={`input${index + 1}`}
                                                       htmlFor={inputType.title}>{inputType.title}</label>

                                                {inputType.description && inputType.description !== "" && (
                                                    <div title={inputType.description}>

                                                        <FaInfoCircle className={"input-info-icon"}/>

                                                    </div>

                                                )}

                                            </div>
                                            <div className="control">
                                                <Field
                                                    name={inputType.title}
                                                    type="text"
                                                    className="custom-input"
                                                    placeholder={inputType.title}
                                                    key={"field" + inputType.id}
                                                    maxLength="700"
                                                />
                                                <ErrorMessage name={inputType.title} render={renderError}/>
                                            </div>

                                        </div>

                                    );
                                }
                            })}
                            {userRole && userRole !== "ROOTADMIN" && (
                                <div className="field">
                                    <label htmlFor="creteByExpertCaseNumber" className="checkbox-label">განაცხადის
                                        ნომრის
                                        მინიჭება</label>
                                    <Field checked={creteByExpertCaseNumber}
                                           onChange={(e) => setCreteByExpertCaseNumber(e.target.checked)}
                                           type="checkbox"
                                           name="creteByExpertCaseNumber"/>
                                    <ErrorMessage name="creteByExpertCaseNumber" component="div" className="error"/>
                                </div>
                            )}

                            {creteByExpertCaseNumber && (
                                <div className="field">
                                    <label htmlFor="oldCaseNumber" className="label-font">ძველი საქმის ნომერი</label>
                                    <div className="control">
                                        <Field name="oldCaseNumber" type="text" className="custom-input"
                                               placeholder="შეიყვანეთ ნომერი"/>
                                    </div>
                                    <ErrorMessage name="oldCaseNumber" render={renderError}/>
                                </div>
                            )}
                            <div>
                                <button
                                    type="submit"
                                    className="customButton"
                                >
                                    გაგზავნა
                                </button>
                            </div>
                        </Form>
                    </Formik>
                </div>
            ))}

            <ConfirmationModal
                isOpen={isConfirmationModalOpen}
                onRequestClose={closeConfirmationModal}
                onConfirm={handleFormSubmit}
            />
        </div>
    );
};

export default DashboardApplicationComponentForExpert;